import React, {Component} from 'react';
import auth from '../../../../../../services/auth';
import history from '../../../../../../services/history';
import CenteredLoadingAnimation from '../../../../../../components/CenteredLoadingAnimation';

class Login extends Component {

  componentWillMount() {
    if (auth.token()) {
      history.replace('/');
    } else {
      const language = (navigator.languages && navigator.languages[0]) ||
                        navigator.language ||
                        navigator.userLanguage;
      // Split locales with a region code
      const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];
      auth.login({
        language: languageWithoutRegionCode || 'en',
      });
    }
  }

  render() {
    return <CenteredLoadingAnimation />;
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/layout/App/components/AuthContainer/components/Login/Login.js